module.exports = __webpack_public_path__ + "static/media/icon-home.4385c716.png";